import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  CreateUpdateExamWithTestsDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { useNavigation } from '../../../common/navigation';
import { examData } from '../../../common/spdCore/contexts/ExamContext';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { AddExamConsultations } from '../../components/TestGiving/AddExamConsultations';

type ParamTypes = {
  id: string;
};

export const ExamConsultationsEditorView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();

  const [exam, setExam] = useState<CreateUpdateExamWithTestsDto>();

  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);

  const { id } = useParams<ParamTypes>() as {
    id: string;
  };

  useEffect(() => {
    spd.exams
      .getExam(id)
      .then(exam => {
        setExam(examData(exam));
      })
      .catch(error => {
        console.error('Wystąpił problem z pobraniem badania', error);
      });
  }, [spd.exams, id]);

  const onSave = async () => {
    try {
      if (exam) {
        const ex = await spd.exams.updateWithTests(id, exam);

        setExam(examData(ex));
        setShowSaveErrors(false);
        void nav.goBack();
      }
    } catch (response) {
      setSaveErrors([
        'Wystąpił problem z zapisaniem wymaganych specjalistów w badaniu. ' +
          (await responseErrors(response as ResponseError)),
      ]);
      setShowSaveErrors(true);
      return false;
    }
  };

  const propertyChange = (obj: Partial<CreateUpdateExamWithTestsDto>) => {
    setExam({ ...exam, ...obj });
  };

  return (
    <Card>
      <Card.Header>{`Edycja badania ${exam?.number}`}</Card.Header>
      <Card.Body>
        <AddExamConsultations
          propertyChange={propertyChange}
          neurologist={exam?.neurologist}
          ophthalmologist={exam?.ophthalmologist}
          laryngologist={exam?.laryngologist}
          psychologistConsultation={exam?.psychologistConsultation}
          psychiatrist={exam?.psychiatrist}
        />
        <ValidationAlert
          show={showSaveErrors}
          errors={saveErrors}
          className="mt-3"
        />
        <Button
          type="submit"
          className="w-100 btn btn-lg btn-login mt-3"
          onClick={onSave}
        >
          Zapisz
        </Button>
      </Card.Body>
    </Card>
  );
};
